import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable} from 'rxjs';
import {MonitoredTrain} from '../models/monitored-train';
import { environment } from '../../../../environments/environment';
import { TrainSyncData } from '../models/train-sync-data';
import { map } from 'rxjs/operators';
import { PreprocessingMonitoredTrainService } from './preprocessing-monitored-train.service';
import { TrainEvent } from '../models/trainEvent';
import { MonitoringAlarm } from '../models/monitoring-alarm';
import {MonitoringZabbixHost} from "@/app/features/monitoring/models/monitoring-zabbix-host";

@Injectable({
  providedIn: 'root'
})
export class FaultMonitoringDataService {

  constructor(
    private http: HttpClient,
    private preprocessingMonitoredTrainService: PreprocessingMonitoredTrainService
  ) { }

  getAllTrains = (projectId: number, usedFields?: string) :  Observable<MonitoredTrain[]> => {
    return this.http.get<MonitoredTrain[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainsList}?projectId=${projectId}`)
    .pipe(map(trains => this.preprocessingMonitoredTrainService.trainList(trains) ))
  }

  getTrain = (projectId: number, trainId: number) :  Observable<MonitoredTrain> => {
    return this.http.get<MonitoredTrain>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainsList}/${trainId}?projectId=${projectId}`)
    .pipe(map(train => this.preprocessingMonitoredTrainService.singleTrain(train) ))
  }

  getTrainSynchronisation = (projectId: number, trainId: number) :  Observable<TrainSyncData[]> => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
    .set('trainId', trainId.toString());
    return this.http.get<TrainSyncData[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainSync}`, {params});
  }

  acknowledgeAlarms = (projectId: number, trainId: number, eventIds: Object): Promise<any> => {
    const params = new HttpParams()
    .set('projectId', projectId.toString())
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.alarm}/acknowledge/${trainId}`, eventIds , {params}).toPromise();
  }

  acknowledgeMonitoringAlarms = (projectId: number, url: string, eventIds: number[]): Promise<any> => {
    const params = new HttpParams()
        .set('projectId', projectId.toString())
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.monitoringAlarm}/acknowledge/${url}`, eventIds , {params}).toPromise();
  }

  getMonitoringAlarms = (projectId: number, monitoringType: string): Observable<MonitoringAlarm[]> => {
    const params = new HttpParams()
        .set('projectId', projectId.toString())
        .set('monitoringType', monitoringType);
    return this.http.get<MonitoringAlarm[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.zabbixAlarms}`, {params}).pipe(
      map(alarms => alarms.map(alarm => {
        return {
          ...alarm,
          severity_label: this.parseSeverity(alarm.severity)
        }
      }))
    )
  }

  getMonitoringHosts = (projectId: number, monitoringType: string): Observable<MonitoringZabbixHost[]> => {
    const params = new HttpParams()
        .set('projectId', projectId.toString())
        .set('monitoringType', monitoringType);
    return this.http.get<MonitoringZabbixHost[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.zabbixHosts}`, {params}).pipe(
        map(hosts => hosts.map(host => {
          return {
            ...host,
            issues: host.issues.map(issue => {
              return {
                ...issue,
                severity_label: this.parseSeverity(issue.severity)
              }
            })
          }
        }))
    )
  }
  getTrainEvents = (projectId: number, trainId?: number) => {
    const params = new HttpParams()
    .set('projectId', projectId.toString());
    if (trainId) {
      return this.http.get<TrainEvent[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainEvents}/${trainId}`, {params});
    } else {
      return this.http.get<TrainEvent[]>(`${environment.api.baseUrl}/${environment.api.endpoints.monitoring.trainEvents}`, {params});
    }
    

   /* EventResource.getTrainEvents().query({
      'projectId': projectId,
      'trainId': trainId
  }).$promise.then(function (data) {
      vm.events = data && data.map(function (event) {
         var message = event.message.replace(/_/g, " ")
          event.message = message.replace('mar3_', '')
          return event;
      })
      vm && vm.tableParamsEvents && vm.tableParamsEvents.reload();
  });*/

  }

  
  parseSeverity = (severity: number) => {
    let label;
    switch (severity) {
      case 0:
        label = 'I18N_MONITORING.NOT_CLASSIFIED';
        break;
      case 1:
        label = 'I18N_MONITORING.INFORMATION';
        break;
      case 2:
        label = 'I18N_MONITORING.LOW';
        break;
      case 3:
        label = 'I18N_MONITORING.MEDIUM';
        break;
      case 4:
        label = 'I18N_MONITORING.HIGH';
        break;
      case 5:
        label = 'I18N_MONITORING.FATAL';
        break;  
      default:
        label = 'N/A'
        break;
    }
    return label;
   }

}
